import React from 'react';
import UserTeamList from './UserTeamList';

export default function UserTeams() {
  return <UserTeamList />;
}
